module.exports = fp;


//////////////////
// WEBPACK FOOTER
// external "fp"
// module id = 20
// module chunks = 0